export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "kAgent.worker.bundle.worker.js");
}
